module.exports = __webpack_public_path__ + "img/horizontal_4_4_7042.05d7fbc9.png";